import { SeoMetaData } from '@cms-max/cms-browser-api-client'
import { Component } from '@cms-max/medicare-api-sdk'

export const accountHomeSeoMetaData: SeoMetaData[] = [
  {
    path: '/home',
    component: Component.AccountHome,
    seo: {
      en: {
        title: `Welcome! | Medicare`,
        description: ''
      },
      es: {
        title: `¡Bienvenido! | Medicare`,
        description: ''
      }
    }
  },
  {
    path: '/home/alloptions',
    component: Component.AccountHomeModal,
    seo: {
      en: {
        title: 'What do you want to do? | Medicare',
        description: ''
      },
      es: {
        title: '¿Qué desea hacer? | Medicare',
        description: ''
      }
    }
  },
  {
    path: '/home/planHistory',
    component: Component.AccountHomePlanHistoryModal,
    seo: {
      en: {
        title: 'Plan history | Medicare',
        description: ''
      },
      es: {
        title: '',
        description: ''
      }
    }
  }
]
